var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "xh-user" }, [
    _vm.headerShow
      ? _c("div", { staticClass: "xh-user__hd" }, [_vm._v("\n    员工\n  ")])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "xh-user__bd" },
      [
        _c("el-input", {
          staticClass: "search-input",
          attrs: {
            disabled: _vm.disabled,
            placeholder: "搜索成员",
            size: "small",
            "prefix-icon": "el-icon-search",
          },
          model: {
            value: _vm.searchInput,
            callback: function ($$v) {
              _vm.searchInput = $$v
            },
            expression: "searchInput",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-list" },
          [
            _c(
              "el-checkbox",
              {
                staticClass: "all-check",
                attrs: {
                  indeterminate: _vm.isIndeterminate,
                  disabled: _vm.radio || _vm.disabled,
                },
                on: { change: _vm.handleCheckAllChange },
                model: {
                  value: _vm.checkAll,
                  callback: function ($$v) {
                    _vm.checkAll = $$v
                  },
                  expression: "checkAll",
                },
              },
              [_vm._v("全选")]
            ),
            _vm._v(" "),
            _c(
              "el-checkbox-group",
              {
                ref: "checkboxGroup",
                attrs: { max: _vm.max, disabled: _vm.disabled },
                on: { change: _vm.checkboxChange },
                model: {
                  value: _vm.dataValue,
                  callback: function ($$v) {
                    _vm.dataValue = $$v
                  },
                  expression: "dataValue",
                },
              },
              _vm._l(_vm.showOptions, function (item, i) {
                return _c(
                  "el-checkbox",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !item.isHide,
                        expression: "!item.isHide",
                      },
                    ],
                    key: i,
                    staticClass: "colleagues-list",
                    attrs: { label: item[_vm.props.value] },
                  },
                  [
                    _c("xr-avatar", {
                      staticClass: "user-img",
                      attrs: {
                        name: item[_vm.props.label],
                        size: 24,
                        src: item.img || item.thumb_img,
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item[_vm.props.label]))]),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "xh-user__ft" },
      [
        _c("span", { staticClass: "select-info" }, [
          _vm._v("已选择"),
          _c("span", { staticClass: "select-info--num" }, [
            _vm._v(_vm._s(_vm.value ? _vm.value.length : 0)),
          ]),
          _vm._v("项"),
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.clearAll } },
          [_vm._v("清空")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }